import { render, staticRenderFns } from "./GP2BrowserQtlTable.vue?vue&type=template&id=77b4b718&scoped=true&"
import script from "./GP2BrowserQtlTable.vue?vue&type=script&lang=js&"
export * from "./GP2BrowserQtlTable.vue?vue&type=script&lang=js&"
import style0 from "./GP2BrowserQtlTable.vue?vue&type=style&index=0&id=77b4b718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4b718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b4b718')) {
      api.createRecord('77b4b718', component.options)
    } else {
      api.reload('77b4b718', component.options)
    }
    module.hot.accept("./GP2BrowserQtlTable.vue?vue&type=template&id=77b4b718&scoped=true&", function () {
      api.rerender('77b4b718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/gp2Browser/GP2BrowserQtlTable.vue"
export default component.exports